const projects = [
  {
    title: 'Incubes',
    description: `<p>In an era of robust global trade, shipping containers are ubiquitous. Strong, durable and produced en mass, they also represent a dynamic solution to the critical affordable housing shortages that face many of today’s growing cities.</p>

    <p>The visual identity and website is based on a functional and modular grid system that clearly references the the modularity in container housing. We aimed for a corporate yet playful identity. The website is based on a light custom vw-based CSS framework for a square website grid.</p>`,
    year: 2017,
    url: 'incubes.dk',
    path: '/incubes',
    images: [
      '/static/images/incubes/business-card-1-web.jpg',
      '/static/images/incubes/incubes-logo-3.jpg'
    ],
    fields: ['Creative direction', 'Branding', 'Identity', 'Web']
  },
  {
    title: 'Clean Sound',
    description: `<p>In 1971, AM started developing products to make your analogue audio collection deliver the cleanest sound possible. Sound that makes you feel as though you’re there in the recording studio. A 3D, tangible music experience.</p>

    <p>The packaging back then was inspired by modernist functionalism, the simplified forms of AM products transcend their everyday function.
    Every object has been reduced to an essential form, erased of unnecessary detail. The products, packaging and visual identity we have developed for AM share the same palette of black and white as the original AM graphics of the 1970s, the same honesty and robustness. It’s a language of fetishized simplicity.</p>

    <p>We have worked closely with AM from idea to execution. Our tasks have included product design, packaging, visual identity, partnerships and collaborations, supply chain, logistics, PR, marketing, digital strategy, retail strategy and sales.</p>`,
    year: 2016,
    url: 'cleansoundam.com',
    path: '/clean-sound',
    images: [
      '/static/images/clean-sound/wooden-box-closeup.jpg'
      // '/static/images/clean-sound/clean-sound-poster-3.jpg',
      // '/static/images/clean-sound/clean-sound-poster-2.jpg',
      // '/static/images/clean-sound/clean-sound-poster-1.jpg'
    ],
    fields: ['Creative direction', 'Branding', 'Identity', 'Web']
  },
  {
    title: 'Get Clean',
    description: `<p>For the most part, nobody likes to clean, it’s just not very fun. But we all love to have good look’n devices. What if we actually wanted to clean because the things we’d use for cleaning made it fun? Complimenting our favourite gadgets, the tools we use to clean with should look great &mdash; feel great &mdash; and perform great.</p>

    <p>We have worked closely with AM from idea to execution. Our tasks have included product design, packaging, visual identity, partnerships and collaborations, supply chain, logistics, PR, marketing, digital strategy, retail strategy and sales.</p>

    <p>We wanted to expose the dirty truth about our filthy gadgets. We came up with some gross statements and teamed up with artist Geoff McFetridge to create some fun illustrations to match the "dirty facts". On product design and packaging we worked with New York based Aruliden, and stop-motion animations are made in collaboration with Todd St. John and his animation studio HunterGatherer.</p>`,
    year: 2016,
    url: 'getcleanam.com',
    path: '/get-clean',
    images: [
      '/static/images/get-clean/process-2.jpg'
    ],
    fields: ['Creative direction', 'Branding', 'Identity', 'Web'],
    awards: [
      'Red Dot Design Award',
      'Core 77 Design Awards',
      'German Design Award',
      'IDEA',
      'The Dyeline Awards',
      "Art Directors' Club",
      'American Packaging Design Award'
    ]
  }
  // {
  //   title: 'Een',
  //   description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eodem modo is enim tibi nemo dabit, quod, expetendum sit, id esse laudabile. Tu vero, inquam, ducas licet, si sequetur; Cum salvum esse flentes sui respon dissent, rogavit essentne fusi hostes. Eod em modo is enim tibi nemo dabit, quod, expet endum sit',
  //   year: 2017,
  //   path: '/een',
  //   images: [
  //     '/static/images/een/een-poster-outdoor-1.jpg'
  //   ],
  //   fields: ['Creative direction', 'Branding', 'Identity', 'Web']
  // },
  // {
  //   title: 'By Wood',
  //   description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eodem modo is enim tibi nemo dabit, quod, expetendum sit, id esse laudabile. Tu vero, inquam, ducas licet, si sequetur; Cum salvum esse flentes sui respon dissent, rogavit essentne fusi hostes. Eod em modo is enim tibi nemo dabit, quod, expet endum sit',
  //   year: 2017,
  //   path: '/by-wood',
  //   images: [
  //     '/static/images/by-wood/by-wood-stamp-1.jpg',
  //     '/static/images/by-wood/by-wood-card-1.jpg',
  //     '/static/images/by-wood/by-wood-card-2.jpg',
  //     '/static/images/by-wood/by-wood-magazine.jpg',
  //     '/static/images/by-wood/by-wood-stamp-1.jpg',
  //     '/static/images/by-wood/by-wood-stationary.jpg',
  //     '/static/images/by-wood/by-wood-window.jpg',
  //     '/static/images/by-wood/by-wood-word-mark.png'
  //   ],
  //   fields: ['Creative direction', 'Branding', 'Identity', 'Web']
  // }
  // },
  // {
  //   title: 'Hey Student',
  //   description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eodem modo is enim tibi nemo dabit, quod, expetendum sit, id esse laudabile. Tu vero, inquam, ducas licet, si sequetur; Cum salvum esse flentes sui respon dissent, rogavit essentne fusi hostes. Eod em modo is enim tibi nemo dabit, quod, expet endum sit',
  //   year: 2017,
  //   url: 'heystudent.co',
  //   path: '/hey-student',
  //   images: [
  //     'https://unsplash.it/500/500/?random',
  //     'https://unsplash.it/501/501/?random',
  //     'https://unsplash.it/502/502/?random',
  //     'https://unsplash.it/503/503/?random',
  //     'https://unsplash.it/504/504/?random',
  //     'https://unsplash.it/505/505/?random',
  //     'https://unsplash.it/506/506/?random'
  //   ],
  //   fields: ['Creative direction', 'Branding', 'Identity', 'Web']
  // }
]

export default projects



// WEBPACK FOOTER //
// ./src/projects.js